export default __webpack_public_path__ + "static/media/auto1.215d783c.mp4";